// libs
import React, { forwardRef, useMemo } from 'react';

import { cn } from '@lyearn/style';
// components
import { Box } from '@lyearn/ui';
import Tag from '@/modules/corporate/modules/database/fields/components/DatabaseSelect/components/Tag';
// utils
import getSelectedOptions from '@/modules/corporate/modules/database/fields/components/DatabaseSelect/utils/getSelectedOptions';
//hooks
import useKeyboard from '@/modules/corporate/modules/database/fields/hooks/useKeyboard';
// types
import { CellProps } from '@/modules/corporate/modules/database/types';

const SelectCell = forwardRef<HTMLDivElement, CellProps>((props: CellProps, ref) => {
  const { toggleIsEditing, columnIndex, rowIndex, column, cellData, className } = props;

  const selectedOption = useMemo(() => {
    const options = column.field.metadataField.options || [];

    if (!options.length || !cellData?.value) {
      return undefined;
    }

    return getSelectedOptions(options, cellData.value)[0];
  }, [cellData?.value, column.field.metadataField.options]);

  const { onKeyDown } = useKeyboard({ onEnterPress: toggleIsEditing });

  return (
    <Box
      ref={ref}
      className={cn('h-full w-full p-8 pe-6', className)}
      data-colindex={columnIndex}
      data-rowindex={rowIndex}
      tabIndex={0}
      onClick={toggleIsEditing}
      onKeyDown={onKeyDown}>
      {selectedOption ? <Tag option={selectedOption} /> : null}
    </Box>
  );
});

export default SelectCell;
